import { RequestService } from '../../services/RequestService';
import { GET_PROFILE_STATUS } from '../constants';

export const getProfileStatus = payload => {
  return RequestService.get(GET_PROFILE_STATUS);
};
